import axios from 'axios';

export default function buscaTypesense() {
  const forms = document.querySelectorAll("#form-busca-typesense");
  const resultadosContainer = document.getElementById("resultados-container");

  // Função para pegar o parâmetro da URL
  function getQueryFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('q') || '';
  }

  // Função para realizar a busca
  function fazerBusca(query) {
    if (!query) return;

    axios
      .get(`/typesense_search/`, {
        params: { q: query }
      })
      .then((response) => {
        renderizarResultados(response.data);
      })
      .catch((error) => {
        console.error("Erro na busca:", error);
        resultadosContainer.innerHTML = `<p class="text-red-500">Erro ao buscar resultados.</p>`;
      });
  }

  // Função para renderizar os resultados da busca
  function renderizarResultados(data) {
    let htmlFinal = "";

    for (const [chave, resultado] of Object.entries(data)) {
      const hits = resultado?.hits || [];

      if (!Array.isArray(hits) || hits.length === 0) continue;

			const tituloSeccao = chave.replace(/[_-]+/g, " ").toUpperCase();
 
      const htmlSecao = hits
        .map((item) => { 
          const doc = item.document;
          const highlight = item.highlight?.titulo?.snippet || doc.titulo || 'Sem título';
          const link = `/${chave}/${doc.slug ? doc.slug : ''}`; // Ex: /trabalho/5/, /video_instagram/2/

          return `
            <div class="resultado-item  ">
              <a href="${link}" class="hover:underline">
                ${highlight}
                <button >[+]</button>
              </a>
            </div>
          `;
        })
        .join("");

      htmlFinal += `
        <div class="resultado-secao resultado-secao-typesense mb-16">
          <h3 class="resultado-title-section stripe">${tituloSeccao}</h3>
          ${htmlSecao}
        </div>
      `;
    }

    resultadosContainer.innerHTML = htmlFinal || `<p class="text-gray-500">Nenhum resultado encontrado.</p>`;
  }

  // Verificar se há parâmetro "q" na URL e fazer a busca automaticamente
  const queryFromUrl = getQueryFromUrl();
  if (queryFromUrl) {
    fazerBusca(queryFromUrl);  // Realiza a busca automaticamente com o valor do parâmetro "q"
  }

  // Adicionar o evento de envio de formulário
  forms?.forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const query = form.querySelector("#search-input")?.value.trim();
      if (query) fazerBusca(query);
    });
  });
}
